import React, { Component } from "react";
import "./LicenseInfo.css";
// import EditableCell from '../components/EditableCell'
import {
    Card, Row, Col, Divider, List, Icon,Button
} from 'antd';

export default class LicenseInfo extends Component {
    // constructor(props) {
    //     super(props);

    // }
    componentDidMount() {
        try {
        } catch (e) {
            alert(e);
        }
    }

    render() {

        return <div className="LicenseInfo">
            <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                <h3 >License Information</h3>
            </Row>
            <Divider />
            <Row type="flex" justify="space-around">
                <Col span={9}>
                    <Card title="Free License" bordered={true}>
                        <List
                            bordered={false}
                        >
                            <List.Item><Icon type="check" /> Create MCA project</List.Item>
                            <List.Item><Icon type="check" /> AHP evaluation method</List.Item>
                            <List.Item><Icon type="check" /> SMART evaluation method</List.Item>
                        </List>
                    </Card>
                </Col>
                <Col span={9}>
                    <Card title="MAMCA License *" bordered={true}>
                        <List
                            bordered={false}
                        >
                            <List.Item><Icon type="check" /> Create MCA project</List.Item>
                            <List.Item><Icon type="check" /> <b> Create MAMCA project</b></List.Item>
                            <List.Item><Icon type="check" /> AHP evaluation method</List.Item>
                            <List.Item><Icon type="check" /> SMART evaluation method</List.Item>
                            <List.Item><Icon type="check" /> <b> Co-creation and co-design **</b></List.Item>
                            <List.Item><Icon type="check" /> <b> Share projects in the group ***</b></List.Item>
                        </List>
                    </Card>
                </Col>
            </Row>
            <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                <Button type="primary" size="large">
                <a href="mailto:info@mamca.eu">Contact us for more info!</a>  
        </Button>
            </Row>
            <Divider />
            <p>* When a new account is created, user will get 1 month MAMCA trial license. For trial license, each project <b>can only create up to 3 alternatives and 3 stakeholder groups</b>. After 1 month, user can still use the software with free license. </p>
            <p>** User with MAMCA license can invite other users or new users to evaluate the projects.</p>
            <p>*** For users in the same organization/institution, if they all buy the MAMCA licenses, a group will be created, projects can be shared within the group.</p>
        </div>;
    }
}
